import { FC } from 'react'
import { SubscriptionDetail, SubscriptionSummary } from 'common/types/responses'
import Badge from 'components/base/Badge'
import { enumeration } from 'common/utils/string/enumeration'
import classNames from 'classnames'

type KYCStatusType = {
  subscription: SubscriptionDetail | SubscriptionSummary
  className?: string
}

const KYCStatus: FC<KYCStatusType> = ({ className, subscription }) => {
  if (!subscription) return null
  return (
    <div className={classNames('d-flex align-items-center', className)}>
      <Badge
        className={className}
        theme={
          subscription.status === 'ACTIVE'
            ? 'success'
            : subscription.status === 'NO_ID'
              ? 'warning'
              : 'danger'
        }
      >
        {enumeration.get(subscription.status)}
      </Badge>
    </div>
  )
}

export default KYCStatus
